var map = {
	"./birzeit_logo.png": 84,
	"./cyberx_logo.png": 39,
	"./grids_logo.svg": 85,
	"./gsg_logo.svg": 86,
	"./iconnect_logo.png": 87,
	"./ministry_logo.jpg": 88,
	"./profile_photo_white.jpg": 89,
	"./shufat_logo.jpg": 90,
	"./tamkeen_logo.png": 91
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;